<template>
<el-dialog
  title="首次生成分卷"
  :modal="true"
  :visible.sync="dialogVisible"
  :close-on-press-escape="false"
  :close-on-click-modal="false"
  width="30%"
  custom-class="seriesPopup"
  :before-close="close">
  <p><el-input placeholder="请输入首次生成分卷数（一次最多5卷）" type="number" v-model="num"></el-input></p>
  <p class="series-tips"><i class="el-icon-warning-outline t-m-r-3"></i>分批次生成分卷，可以让剧情更贴合，更紧密，若无要求也可以直接生成全部分卷。</p>
  <span slot="footer" class="dialog-footer">
    <el-button class="series-tips" @click="allClick">生成全部分卷</el-button>
    <el-button type="primary" @click="submitClick">确 定</el-button>
  </span>
</el-dialog>
</template>
<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        num:'',
      };
    },
    methods: {
      close() {
        this.dialogVisible = false
      },
      open(){
        this.num = ''
        this.dialogVisible = true
      },
      submitClick(){
        if(!/^[1-5]$/.test(this.num)){
            this.$message.warning('请输入首次分卷数量为1~5之间！')
            return
        }
        this.$emit('submit',this.num)
        this.close()
      },
      allClick(){
        this.$emit('allCreate')
        this.close()
      }
    }
  };
</script>
<style>
.seriesPopup{
    background-color: #fff !important;
    border-radius: 10px !important;
}
</style>
<style lang="scss" scoped>
.series-tips{
    color: red;
}
</style>